<rk-sidenav-action-wrapper
  [title]="'SCHEDULE.PLANNING.ADD_SLOT' | translate"
  (cancelled)="closePanel()"
  [hideBottom]="true"
  [enableScrollbar]="false"
>
  <div class="filter-events">
    <rk-search-bar
      type="full"
      (inputted)="onChangeSearch($event)"
      (closed)="onChangeSearch('')"
    ></rk-search-bar>
    <div class="boxes" *ngIf="tagList.length > 2">
      <ng-container *ngFor="let tag of tagList">
        <span
          class="tag"
          (click)="selectType(tag.id)"
          [ngClass]="{ selected: tag.id === selectedType.value }"
        >
          {{ tag.translationKey | translate }}
        </span>
      </ng-container>
    </div>
  </div>
  <div id="fc-external" class="events">
    <ng-container
      *ngIf="
        (playlists$ | async)?.length || (programs$ | async)?.length;
        else searchEmpty
      "
    >
      <ng-container
        *ngIf="selectedType.value !== 'program' && (playlists$ | async)?.length > 0"
      >
        <div class="section-title" translate>
          SCHEDULE.PLANNING.EDIT_MODAL_TAB_PLAYLIST
        </div>
        <div class="list-group" [style.max-height.px]="$playlistMaxHeight()">
          <div
            class="fc-event fc-playlist truncate gap-4 flex relative bg-white items-center p-2.5"
            *ngFor="let playlist of playlists$ | async; let i = index"
            [attr.data-id]="playlist.id"
            [attr.data-color]="playlist.color"
          >
            <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
            <div class="name truncate">{{ playlist.name }}</div>
            <div
              [attr.data-duration]="playlist.extra['duration']"
              class="duration ml-auto"
            >
              {{ playlist.extra['duration'] | timeFormat }}
            </div>
            <div class="duration duration-hover">
              <rk-button
                btnStyle="orange"
                faIcon="fa-plus"
                [style]="getBtnHoverStyle()"
                (click)="addSlotClicked(playlist, enums.SlotKind.playlist)"
              ></rk-button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="selectedType.value !== 'playlist' && (programs$ | async)?.length > 0"
      >
        <div class="section-title" translate>
          SCHEDULE.PLANNING.EDIT_MODAL_TAB_PROGRAM
        </div>
        <div class="list-group max-h-min">
          <div
            class="fc-event fc-program truncate gap-4 flex relative bg-white items-center p-2.5"
            *ngFor="let program of programs$ | async; let i = index"
            [attr.data-id]="program.id"
            [attr.data-color]="program.color"
          >
            <div
              class="color h-15 md:h-2.5 aspect-square rounded-l md:rounded-sm"
              [style.background]="program.color"
            ></div>
            <div class="name truncate">{{ program.name }}</div>
            <div [attr.data-duration]="program.extra['duration']" class="duration">
              {{ program.extra['duration'] | timeFormat }}
            </div>
            <div class="duration duration-hover">
              <rk-button
                btnStyle="orange"
                faIcon="fa-plus"
                [style]="getBtnHoverStyle()"
                (click)="addSlotClicked(program, enums.SlotKind.program)"
              ></rk-button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <ng-template #searchEmpty>
    <div class="search-empty">
      <img src="/assets/search-empty.svg" alt="" />
      <div>
        {{ 'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.getValue() } }}
      </div>
    </div>
  </ng-template>
</rk-sidenav-action-wrapper>
